import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.from-entries.js";
import "core-js/modules/es.object.to-string.js";
export function useGetTabInfo(_ref) {
  var tabs = _ref.tabs,
    location = _ref.location,
    getTabLink = _ref.getTabLink,
    getIsActiveTab = _ref.getIsActiveTab;
  var tabLinks = Object.fromEntries(tabs.map(function (tabName) {
    var link = getTabLink({
      tabName: tabName,
      location: location
    });
    var isActive = getIsActiveTab({
      location: location,
      tabName: tabName
    });
    return [tabName, {
      link: link,
      isActive: isActive
    }];
  }));

  // Find the active tab
  var activeTab = tabs.find(function (tabName) {
    return tabLinks[tabName].isActive;
  }) || 'details';
  return {
    tabLinks: tabLinks,
    activeTab: activeTab
  };
}